import {Grid} from 'platform/foundation';

import type {ReactNode} from 'react';

import {CHART_GRID_COLUMNS} from '../../constants/CHART_GRID_COLUMNS';
import {ChartGridContext} from '../../contexts/ChartGridContext';

// The space between chart cards, the same as between the other parts of a reporting tab.
const CHART_GRID_SPACING = 6;

interface ChartGridProps {
  /** Id of the grid, usually the tab, for example `workshop.salesPerformance`. */
  layoutId: string;
  /** `ChartGridItem` elements, in their fixed order. */
  children: ReactNode;
}

/**
 * Grid of chart cards. The chart layout of the page sets each card to full or half width, and two
 * half-width cards that follow each other share a row. Without a chart layout, every card has the
 * full width.
 */
export function ChartGrid(props: ChartGridProps) {
  return (
    <ChartGridContext.Provider value={props.layoutId}>
      <Grid columns={CHART_GRID_COLUMNS} spacing={CHART_GRID_SPACING}>
        {props.children}
      </Grid>
    </ChartGridContext.Provider>
  );
}
